export default __webpack_public_path__ + "static/media/not_designerReport.662bc3f7.png";